import { mdiMonitor, mdiWeatherNight, mdiWhiteBalanceSunny } from '@mdi/js'
import { AppIcon } from './ui/icon'
import { Button } from './ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu'
import { useTheme } from '../contexts/ThemeContext'

export function ThemeToggle() {
  const { theme, setTheme } = useTheme()

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="w-9 h-9 px-0"
          data-testid="theme-toggle"
        >
          <AppIcon path={mdiWhiteBalanceSunny} size="md" className="rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
          <AppIcon path={mdiWeatherNight} size="md" className="absolute rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
          <span className="sr-only">Toggle theme</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem
          onClick={() => setTheme('light')}
          className={theme === 'light' ? 'bg-accent text-accent-foreground' : ''}
          data-testid="theme-light"
        >
          <AppIcon path={mdiWhiteBalanceSunny} size="sm" className="mr-2" />
          <span>Light</span>
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => setTheme('dark')}
          className={theme === 'dark' ? 'bg-accent text-accent-foreground' : ''}
          data-testid="theme-dark"
        >
          <AppIcon path={mdiWeatherNight} size="sm" className="mr-2" />
          <span>Dark</span>
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => setTheme('system')}
          className={theme === 'system' ? 'bg-accent text-accent-foreground' : ''}
          data-testid="theme-system"
        >
          <AppIcon path={mdiMonitor} size="sm" className="mr-2" />
          <span>System</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
